import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./navbar.css";

const Navbar = (props) => {

    const [offset, setOffset] = useState(0);
    let navRef = useRef();
    let logoRef = useRef();

    const navigating = useNavigate()

    const toHome = () => {
        props.workRef.current.style.opacity = 0;
        props.workRef.current.style.transition = "all 0.5s ease-in-out";

        setTimeout(() => {

            navigating('/')

        }, 600)
    }

    const toContact = () => {
        props.workRef.current.style.transform = "translateY(-100%)";
        props.workRef.current.style.transition = "all 0.5s ease-in-out";

        setTimeout(() => {

            navigating('/contact');

        }, 600)
    }

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => {

        if (offset > 0) {

            navRef.current.style.background = "rgb(11 11 12 / 95%)";
            navRef.current.style.backdropFilter = "blur(5px)";
            navRef.current.style.transition = "all 0.6s";
            navRef.current.style.boxShadow = "2px 2px 15px rgba(0, 0, 0, 0.7)";
            navRef.current.style.height = "10vh";

            logoRef.current.style.width = "10em";
            logoRef.current.style.transition = "all 0.6s";

        }
        else {

            navRef.current.style.background = "transparent";
            navRef.current.style.boxShadow = "none";
            navRef.current.style.backdropFilter = "blur(0px)";
            navRef.current.style.height = "15vh";

            logoRef.current.style.width = "13em";
        }
    }, [offset]);

    return (
        <>
            <nav ref={navRef}>
                <div className="logo">
                    {
                        (props.textcolor == "rgb(252, 246, 244)") ? <img ref={logoRef} src="images/s1wP.png" alt="logo" /> : <img ref={logoRef} src="images/s1bP.png" alt="logo" />
                    }
                </div>

                <div className="menu" onClick={toHome}>
                    <span style={{ background: props.textcolor }}><i className="fas fa-power-off"></i></span>
                </div>

                <div className="contactME">
                    {/* <h1 onClick={toContact} style={{ color: props.textcolor }}> Say hi.. </h1> */}
                </div>

            </nav>
        </>
    )
}

export default Navbar;